export default "__VITE_ASSET__0057dc0d__"